<template>
  <div class="modal-overlay" :class="{ show: visible }">
    <div class="modal-content" @click.stop>
      <!-- 头部 -->
      <div class="modal-header">
        <h3 class="modal-title">
          <i class="fas fa-copyright"></i>
          {{ $t('_ggtf._hdxq') }}
        </h3>
        <button class="close-btn" @click="visible = false">
          <CloseCircleOutlined />
        </button>
      </div>

      <!-- 主体 -->
      <div class="modal-body">
        <div class="detail-cover">
          <img :src="current.img" :alt="current.title" class="detail-image" />
          <div class="cover-tag" v-if="current.status === 1">
            <span class="tag-active">进行中</span>
          </div>
        </div>

        <div class="detail-info">
          <h4 class="detail-title">{{ current.title }}</h4>
          <div class="detail-code">#{{ current.code }}</div>

          <!-- 活动介绍 -->
          <div class="detail-section">
            <div class="section-header">
              <span class="section-dot"></span>
              <h5>{{ $t('_ggtf._hdjs') }}</h5>
            </div>
            <p class="detail-desc">{{ current.content || '暂无活动介绍' }}</p>
          </div>

          <!-- 投资信息 -->
          <div class="detail-section">
            <div class="section-header">
              <span class="section-dot"></span>
              <h5>投资信息</h5>
            </div>
            <div class="info-cards">
              <div class="info-card">
                <span class="info-card-label">投资单价</span>
                <span class="info-card-value price">${{ current.price }}</span>
              </div>
              <div class="info-card">
                <span class="info-card-label">活动天数</span>
                <span class="info-card-value">{{ current.days }} 天</span>
              </div>
              <div class="info-card">
                <span class="info-card-label">VIP等级</span>
                <span class="info-card-value">Lv.{{ current.level }}</span>
              </div>
              <div class="info-card">
                <span class="info-card-label">人均参与</span>
                <span class="info-card-value">{{ current.pre_num }} 次</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部 -->
      <div class="modal-footer">
        <button class="btn-cancel" @click="visible = false">
          <i class="fas fa-times"></i>
          {{ $t('_ggtf._qx') }}
        </button>
        <button class="btn-confirm" @click="onSubmit">
          <i class="fas fa-check"></i>
          {{ $t('_bq._ljzf') }}
        </button>
      </div>
    </div>

    <!-- 密码输入框 -->
    <ToastPassword ref="pay" @sumbit="onPwdSubmit" :okText="$t('_ggtf._ljcy')" />
  </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import ToastPassword from './ToastPassword.vue'

export default {
  name: 'InvestBuyVue',
  components: {
    ToastPassword,
    CloseCircleOutlined
  },
  data() {
    return {
      visible: false,
      current: {},
      pay_code: ''
    }
  },
  methods: {
    open(item, pay_code) {
      this.visible = true
      this.current = item || {}
      this.pay_code = pay_code || ''
    },

    onSubmit() {
      this.$refs.pay?.open()
    },

    onPwdSubmit(passwd) {
      this.$message.loading({ content: this.$t('_ggtf._zfz'), key: 'msg' })

      this.$api.videoInvest
        .payInvest({
          code: this.pay_code,
          passwd: passwd
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.warning({ content: res.msg, key: 'msg' })
            this.$refs.pay?.resetLoading?.()
            return
          }
          this.$refs.pay?.close()
          this.visible = false
          this.$message.success({ content: res.msg || '支付成功', key: 'msg' })
          this.$emit('success')
        })
        .catch(() => {
          this.$refs.pay?.resetLoading?.()
        })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   投资购买弹窗 - 深灰主题
   ============================================================ */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.35s ease;
}

.modal-overlay.show {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  width: 640px;
  max-width: 94vw;
  max-height: 90vh;
  background: #1a1f26;
  border-radius: 16px;
  border: 1px solid #2a3038;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: scale(0.92) translateY(24px);
  transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.modal-overlay.show .modal-content {
  transform: scale(1) translateY(0);
}

/* ============================================================
   头部
   ============================================================ */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #2a3038;
  flex-shrink: 0;
}

.modal-title {
  margin: 0;
  color: #e8edf2;
  font-size: 19px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-title i {
  color: #ffb300;
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #5a6672;
  cursor: pointer;
  font-size: 22px;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 179, 0, 0.1);
  color: #ffb300;
  transform: rotate(90deg);
}

/* ============================================================
   主体
   ============================================================ */
.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  gap: 20px;
}

.modal-body::-webkit-scrollbar {
  width: 4px;
}

.modal-body::-webkit-scrollbar-track {
  background: transparent;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #2a3038;
  border-radius: 4px;
}

/* ============================================================
   封面
   ============================================================ */
.detail-cover {
  flex: 0 0 200px;
  /* height: 260px; */
  border-radius: 12px;
  overflow: hidden;
  background: #0a0d0f;
  border: 1px solid #2a3038;
  position: relative;
}

.detail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-tag {
  position: absolute;
  top: 10px;
  right: 10px;
}

.tag-active {
  display: inline-block;
  padding: 3px 14px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background: rgba(38, 166, 154, 0.85);
  color: #fff;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* ============================================================
   信息区
   ============================================================ */
.detail-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-title {
  font-size: 19px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0;
}

.detail-code {
  font-size: 13px;
  color: #5a6672;
  font-family: monospace;
  margin-top: -6px;
}

/* ============================================================
   区块
   ============================================================ */
.detail-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-dot {
  width: 4px;
  height: 16px;
  background: #ffb300;
  border-radius: 4px;
  flex-shrink: 0;
}

.section-header h5 {
  font-size: 14px;
  font-weight: 600;
  color: #8a949f;
  margin: 0;
}

.detail-desc {
  font-size: 14px;
  color: #b0bcc8;
  line-height: 1.7;
  margin: 0;
  padding: 8px 14px;
  background: #0a0d0f;
  border-radius: 8px;
  border: 1px solid #2a3038;
}

/* ============================================================
   投资信息卡片
   ============================================================ */
.info-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.info-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;
  background: #0a0d0f;
  border-radius: 8px;
  border: 1px solid #2a3038;
}

.info-card-label {
  font-size: 10px;
  color: #5a6672;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.info-card-value {
  font-size: 15px;
  color: #e8edf2;
  font-weight: 600;
}

.info-card-value.price {
  color: #ffb300;
}

/* ============================================================
   底部
   ============================================================ */
.modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #2a3038;
  flex-shrink: 0;
}

.btn-cancel {
  flex: 1;
  padding: 10px 20px;
  border: 1px solid #2a3038;
  border-radius: 30px;
  background: transparent;
  color: #8a949f;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-cancel:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: #3a4652;
  color: #e8edf2;
}

.btn-confirm {
  flex: 2;
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(255, 179, 0, 0.2);
}

.btn-confirm:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(255, 179, 0, 0.35);
}

.btn-confirm:active {
  transform: scale(0.97);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 640px) {
  .modal-content {
    max-width: 96vw;
    max-height: 94vh;
    border-radius: 12px;
  }

  .modal-header {
    padding: 14px 16px;
  }

  .modal-title {
    font-size: 16px;
  }

  .modal-body {
    padding: 14px 16px;
    flex-direction: column;
  }

  .detail-cover {
    flex: 0 0 auto;
    height: 160px;
    width: 100%;
  }

  .detail-title {
    font-size: 17px;
  }

  .info-cards {
    grid-template-columns: 1fr 1fr;
  }

  .modal-footer {
    padding: 14px 16px;
    flex-direction: column;
    gap: 8px;
  }

  .btn-cancel,
  .btn-confirm {
    padding: 10px;
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .detail-cover {
    /* height: 130px; */
  }

  .detail-title {
    font-size: 15px;
  }

  .info-cards {
    grid-template-columns: 1fr;
  }

  .info-card {
    padding: 8px 12px;
  }

  .info-card-value {
    font-size: 14px;
  }

  .detail-desc {
    font-size: 13px;
    padding: 6px 12px;
  }
}
</style>